/*
 * FocusDirective.js
 *
 * Author: Kevin Dench <kevin.dench@intellidata.net>
 * Author: IntelliData, Inc.
 * License: Proprietary
 * Version: 1.0
 * Copyright: 2017.
 */

/* @ngInject */
export default function FocusDirective($timeout, $parse) {
    return {
        restrict: 'A',
        scope: {
            trigger: '@focusInput'
        },
        link: function (scope, element) {
            var model = $parse('trigger');
            scope.$watch(model, function (hasFocus) {
                if (hasFocus === 'true') {
                    $timeout(function () {
                        element[0].focus();
                    });
                }
            });
            element.bind('blur', function () {
                console.log('blur');
                scope.$apply(model(scope, false));
            });
        }
    };
}
